/*
 * Sticky buy bar (mobile, product pages only).
 *
 * Instead of duplicating the ".price-buy-block" markup (which would create
 * duplicate form ids and a second <product-form-component>, breaking add-to-cart),
 * we relocate the live DOM node into a fixed container appended before </body>.
 * Moving the node keeps the form, price and variant logic intact while making
 * position:fixed reliable, since the bar is now a direct child of <body>.
 *
 * On desktop the node is moved back to its original place in the product layout.
 * The footer is raised by exactly the bar height via the --sticky-buy-bar-height
 * custom property (see base.css).
 */
(function () {
  var MOBILE_QUERY = '(max-width: 750px)';

  var bar = document.getElementById('sticky-buy-bar');
  if (!bar) return;

  var mq = window.matchMedia(MOBILE_QUERY);
  var block = null;
  var anchor = null; // marks the block's original position for desktop restore
  var currentBasePriceCents = null;
  var currentBasePriceText = null;
  var currentCompareAtPriceText = null;

  function findBlock() {
    // The in-page block, not one already inside our bar.
    var nodes = document.querySelectorAll('.price-buy-block');
    for (var i = 0; i < nodes.length; i++) {
      if (!bar.contains(nodes[i])) return nodes[i];
    }
    return bar.querySelector('.price-buy-block');
  }

  function setHeight() {
    var height = bar.hidden ? 0 : bar.offsetHeight;
    document.body.style.setProperty('--sticky-buy-bar-height', height + 'px');
  }

  function getVisiblePriceText() {
    var activeBlock = bar.querySelector('.price-buy-block');
    if (!activeBlock) return '';

    var salePrice = activeBlock.querySelector('.price__sale:not(.price__hidden) .price-item--sale');
    var regularPrice = activeBlock.querySelector('.price__regular:not(.price__hidden) .price');
    var anyPrice = activeBlock.querySelector('.price');

    return (salePrice || regularPrice || anyPrice || {}).textContent || '';
  }

  function getDecimalPlaces(text) {
    var match = String(text).match(/([.,])(\d{1,2})(?!.*[.,]\d)/);
    return match ? match[2].length : 0;
  }

  function formatPriceFromCents(cents, template) {
    var source = String(template || currentBasePriceText || getVisiblePriceText() || '');
    var decimals = getDecimalPlaces(source);
    var value = (cents / 100).toFixed(decimals);
    var parts = value.split('.');
    var integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var decimalPart = parts[1] ? '.' + parts[1] : '';
    var formattedNumber = integerPart + decimalPart;

    var replaced = source.replace(/[-+]?\d(?:[\d,.]*\d)?/, formattedNumber);
    return replaced === source ? formattedNumber : replaced;
  }

  function parseMoneyToCents(text) {
    var value = String(text || '').replace(/\s/g, '').replace(/[^\d,.\-+]/g, '');
    if (!value) return 0;

    var sign = value.indexOf('-') !== -1 ? -1 : 1;
    value = value.replace(/[+\-]/g, '');

    var lastComma = value.lastIndexOf(',');
    var lastDot = value.lastIndexOf('.');
    var decimalSeparator = lastComma > lastDot ? ',' : '.';
    var decimalIndex = value.lastIndexOf(decimalSeparator);
    var hasDecimals = decimalIndex !== -1 && value.length - decimalIndex - 1 <= 2;

    var normalized;
    if (hasDecimals) {
      normalized =
        value.slice(0, decimalIndex).replace(/[,.]/g, '') + '.' + value.slice(decimalIndex + 1).replace(/[,.]/g, '');
    } else {
      normalized = value.replace(/[,.]/g, '');
    }

    var amount = parseFloat(normalized);
    if (!Number.isFinite(amount)) return 0;

    return Math.round(amount * 100) * sign;
  }

  function getGpoOptionPriceText(optionElement) {
    var priceElement =
      optionElement.querySelector('.gpo-swatch-price') ||
      optionElement.querySelector('.addOn') ||
      optionElement.querySelector('[class*="price"]');

    return priceElement ? priceElement.textContent : optionElement.textContent;
  }

  function getSelectedGpoAddonCents() {
    var total = 0;
    var app = document.querySelector('.gpo-app');
    if (!app) return total;

    var activeItems = app.querySelectorAll('.gpo-swatch-item.gpo-is-active');
    activeItems.forEach(function (item) {
      total += parseMoneyToCents(getGpoOptionPriceText(item));
    });

    var checkedInputs = app.querySelectorAll('input:checked');
    checkedInputs.forEach(function (input) {
      if (input.closest('.gpo-swatch-item.gpo-is-active')) return;

      var option =
        input.closest('.gpo-swatch-item') ||
        input.closest('.gpo-checkbox') ||
        input.closest('.gpo-choicelist') ||
        input.closest('.globo-form-control') ||
        input.parentElement;

      if (option) {
        total += parseMoneyToCents(getGpoOptionPriceText(option));
      }
    });

    var selectedOptions = app.querySelectorAll('select option:checked');
    selectedOptions.forEach(function (option) {
      total += parseMoneyToCents(getGpoOptionPriceText(option));
    });

    return total;
  }

  function setPriceText(root, priceText, compareAtPriceText) {
    if (!root || !priceText) return;

    var regularPrice = root.querySelector('.price__regular');
    var salePrice = root.querySelector('.price__sale');
    var regularPriceText = regularPrice && regularPrice.querySelector('.price');
    var salePriceText = salePrice && salePrice.querySelector('.price-item--sale');
    var compareAtPrice = salePrice && salePrice.querySelector('.compare-at-price');

    if (compareAtPriceText && compareAtPriceText !== priceText) {
      if (regularPrice) regularPrice.classList.add('price__hidden');
      if (salePrice) salePrice.classList.remove('price__hidden');
      if (salePriceText) salePriceText.textContent = priceText;
      if (compareAtPrice) compareAtPrice.textContent = compareAtPriceText;
    } else {
      if (regularPrice) regularPrice.classList.remove('price__hidden');
      if (salePrice) salePrice.classList.add('price__hidden');
      if (regularPriceText) regularPriceText.textContent = priceText;
    }
  }

  function syncCalculatedGpoPrice() {
    if (currentBasePriceCents == null) return;

    var totalPriceText = formatPriceFromCents(currentBasePriceCents + getSelectedGpoAddonCents(), currentBasePriceText);
    var activeBlock = bar.querySelector('.price-buy-block');
    var stickyAddToCartPrice = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__price');

    setPriceText(activeBlock, totalPriceText, currentCompareAtPriceText);
    setPriceText(stickyAddToCartPrice, totalPriceText, currentCompareAtPriceText);
    setHeight();
  }

  function apply() {
    if (!block || !block.isConnected) {
      block = findBlock();
    }
    if (!block) {
      bar.hidden = true;
      setHeight();
      return;
    }

    // Remember where the block lives so we can put it back on desktop.
    if (!anchor || !anchor.isConnected) {
      if (block.parentNode && block.parentNode !== bar) {
        anchor = document.createComment('price-buy-block-anchor');
        block.parentNode.insertBefore(anchor, block);
      }
    }

    if (mq.matches) {
      if (block.parentNode !== bar) bar.appendChild(block);
      bar.hidden = false;
    } else {
      if (anchor && anchor.parentNode && block.parentNode === bar) {
        anchor.parentNode.insertBefore(block, anchor);
      }
      bar.hidden = true;
    }

    setHeight();
  }

  function findSelectedOption(event) {
    if (!event || !(event.target instanceof HTMLElement)) return null;

    var optionValueId = event.detail && event.detail.resource && event.detail.resource.id;
    if (!optionValueId) return null;

    var options = event.target.querySelectorAll('[data-option-value-id]');
    for (var i = 0; i < options.length; i++) {
      if (options[i] instanceof HTMLElement && options[i].dataset.optionValueId === optionValueId) {
        return options[i];
      }
    }

    return null;
  }

  function syncVariantSelection(event) {
    var selectedOption = findSelectedOption(event);
    if (!selectedOption) return;

    var activeBlock = bar.querySelector('.price-buy-block');
    if (!activeBlock) return;

    var variantIdInput = activeBlock.querySelector('input[name="id"]');
    if (variantIdInput && selectedOption.dataset.variantId) {
      variantIdInput.value = selectedOption.dataset.variantId;
    }

    if (!selectedOption.dataset.variantPrice) return;

    var price = selectedOption.dataset.variantPrice;
    var compareAtPrice = selectedOption.dataset.variantCompareAtPrice;
    var priceCents = parseInt(selectedOption.dataset.variantPriceCents || '', 10);
    if (Number.isFinite(priceCents)) {
      currentBasePriceCents = priceCents;
      currentBasePriceText = price;
      currentCompareAtPriceText = compareAtPrice;
    }
    var regularPrice = activeBlock.querySelector('.price__regular');
    var salePrice = activeBlock.querySelector('.price__sale');
    var regularPriceText = regularPrice && regularPrice.querySelector('.price');
    var salePriceText = salePrice && salePrice.querySelector('.price-item--sale');
    var compareAtPriceText = salePrice && salePrice.querySelector('.compare-at-price');

    if (compareAtPrice && compareAtPrice !== price) {
      if (regularPrice) regularPrice.classList.add('price__hidden');
      if (salePrice) salePrice.classList.remove('price__hidden');
      if (salePriceText) salePriceText.textContent = price;
      if (compareAtPriceText) compareAtPriceText.textContent = compareAtPrice;
    } else {
      if (regularPrice) regularPrice.classList.remove('price__hidden');
      if (salePrice) salePrice.classList.add('price__hidden');
      if (regularPriceText) regularPriceText.textContent = price;
    }

    scheduleCalculatedPriceSync();
  }

  function scheduleCalculatedPriceSync() {
    syncCalculatedGpoPrice();
    setTimeout(syncCalculatedGpoPrice, 50);
    setTimeout(syncCalculatedGpoPrice, 60);
    setTimeout(syncCalculatedGpoPrice, 150);
    setTimeout(syncCalculatedGpoPrice, 180);
    setTimeout(syncCalculatedGpoPrice, 350);
    setTimeout(syncCalculatedGpoPrice, 380);
    setTimeout(syncCalculatedGpoPrice, 700);
  }

  function initCurrentVariantPrice() {
    var selectedOption = document.querySelector('variant-picker [data-current-checked="true"][data-variant-price-cents], variant-picker option:checked[data-variant-price-cents]');
    if (!(selectedOption instanceof HTMLElement)) return;

    var priceCents = parseInt(selectedOption.dataset.variantPriceCents || '', 10);
    if (!Number.isFinite(priceCents)) return;

    currentBasePriceCents = priceCents;
    currentBasePriceText = selectedOption.dataset.variantPrice || getVisiblePriceText();
    currentCompareAtPriceText = selectedOption.dataset.variantCompareAtPrice;
  }

  initCurrentVariantPrice();
  apply();

  if (mq.addEventListener) {
    mq.addEventListener('change', apply);
  } else if (mq.addListener) {
    mq.addListener(apply); // Safari < 14
  }

  if (window.ResizeObserver) {
    new ResizeObserver(setHeight).observe(bar);
  }
  window.addEventListener('resize', setHeight);

  // The product section can be re-rendered (theme editor, variant change with
  // section rendering). Re-grab the fresh node and re-apply placement.
  document.addEventListener('shopify:section:load', function () {
    anchor = null;
    block = findBlock();
    apply();
  });

  document.addEventListener('variant:selected', syncVariantSelection);
  document.addEventListener('variant:update', scheduleCalculatedPriceSync);

  document.addEventListener('change', function (event) {
    if (event.target instanceof HTMLElement && event.target.closest('.gpo-app')) {
      scheduleCalculatedPriceSync();
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (event.target instanceof HTMLElement && event.target.closest('.gpo-app')) {
      scheduleCalculatedPriceSync();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target instanceof HTMLElement && event.target.closest('.gpo-app')) {
      scheduleCalculatedPriceSync();
    }
  }, true);
})();
